import {
  WALLDASH_INIT,
  WALLDASH_CHANGE_SCREEN,
  WALLDASH_STATS_INIT,
  WALLDASH_STATS_CHANGE_PROGRESS,
  WALLDASH_STATS_LOAD_DATA
} from './available'

import moment from 'moment'

export default {
  [WALLDASH_INIT](state, screenChangeIntervalId) {
    state.walldash.screenChangeIntervalId = screenChangeIntervalId
  },
  [WALLDASH_CHANGE_SCREEN](state, screenNumber) {
    state.walldash.currentScreen = screenNumber
  },
  [WALLDASH_STATS_INIT](state, {context, updateIntervalId}) {
    state.walldash[context].updateIntervalId = updateIntervalId
  },
  [WALLDASH_STATS_CHANGE_PROGRESS](state, {context, value}) {
    state.walldash[context].inProgress = value
  },
  [WALLDASH_STATS_LOAD_DATA](state, {context, value}) {
    state.walldash[context].data = value
    state.walldash[context].dataLoaded = true
    state.walldash[context].lastUpdate = moment().format('YYYY-MM-DD hh:mm:ss')
  }
}



// WEBPACK FOOTER //
// ./src/store/mutations/walldash.js